import * as React from "react";
// eslint-disable-next-line no-restricted-imports
import {Provider as WrappedProvider} from "react-redux";

import {Server} from "@khanacademy/wonder-blocks-core";

type Props = JSX.LibraryManagedAttributes<
    typeof WrappedProvider,
    React.ComponentProps<typeof WrappedProvider>
>;

/**
 * react-redux assumes that the presence of a DOM implies that we
 * aren't SSR-ing.  This isn't true for us since we use JSDOM to
 * SSR things.  This wrapper, wraps a custom version of react-redux
 * which adds an `ssr` prop to `Provider` to override react-redux's
 * SSR check.
 */
export const Provider: (props: Props) => React.ReactElement = (props) => {
    // @ts-expect-error - TS2769 - No overload matches this call.
    return <WrappedProvider {...props} ssr={Server.isServerSide()} />;
};
